import { store } from "../store/createdStore";

export const useLang = () => {
  const { auth } = store.getState();
  return auth.user && auth.user.lang ? auth.user.lang : localStorage.getItem("lang") ? localStorage.getItem("lang") : "ru";
};
